import { render, staticRenderFns } from "./ItemListDetectionItemLayout.vue?vue&type=template&id=da779f2e&scoped=true&"
import script from "./ItemListDetectionItemLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListDetectionItemLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da779f2e",
  null
  
)

export default component.exports